(function($, window) {
    if (window.mg === undefined)
        window.mg = {};

    var _ = window.mg;
    var baseURL = '/Site/Payment';

    var payment = {
        winRef          : null,
        paymentComplete : false,

        open: function(options) {
            var url = baseURL;

            this.paymentComplete = false;

            if (options.receiptOnly)
                url += '/Receipt';

            if (!this.winRef || this.winRef.closed) {
                var features = [];

                if (!_.isMobile.any && window.matchMedia) {
                    var screenX     = typeof window.screenX != 'undefined' ? window.screenX : window.screenLeft;
                    var screenY     = typeof window.screenY != 'undefined' ? window.screenY : window.screenTop;
                    var outerWidth  = typeof window.outerWidth != 'undefined' ? window.outerWidth : document.documentElement.clientWidth;
                    var outerHeight = typeof window.outerHeight != 'undefined' ? window.outerHeight : document.documentElement.clientHeight - 22;
                    var width       = null;
                    var height      = 500;

                    if (window.matchMedia('(min-width: 992px)').matches)
                        width = 992;
                    if (window.matchMedia('(min-width: 1200px)').matches)
                        width = 1200;

                    if (width !== null) {
                        var left = parseInt((screenX < 0 ? window.screen.width + screenX : screenX) + (outerWidth - width) / 2, 10);
                        var top  = parseInt(screenY + (outerHeight - height) / 2.5, 10);

                        features.push('width=' + width);
                        features.push('height=' + height);
                        features.push('left=' + left);
                        features.push('top=' + top);
                        features.push('scrollbars=1');
                        features.push('toolbar=0');
                        features.push('location=0');
                    }
                }

                this.winRef = window.open(url + '/' + options.id, 'paymentWindow', features.join(','));
                this.createBackOverlay();

                monitor(options.callBackOnClose);
            } else if (this.winRef.location.href.indexOf(url) == -1) {
                this.winRef.location.href = url;
            }

            return this.winRef;
        },

        cancel: function(paymentID, closeWindow) {
            if (closeWindow || !paymentID)
                this.close();
            else
                this.redirect('', paymentID);
        },

        close: function() {
            window.close();
        },

        navigate: function(page, id, window) {
            if (!window)
                window = this.winRef;

            window.location.href = baseURL + (page ? '/' + page : '') + '/' + id;
        },

        chkPaymentAcceptTermsOnChange: function(target) {
            var $target = $(target);
            $('#btnPay').prop('disabled', !$target.prop('checked'));
        },

        btnPayOnClick: function(paymentID) {
            var that = this;

            var o = {
                paymentID  : paymentID,
                address    : $('#txtPaymentAddr').val(),
                postNumber : $('#txtPaymentZip').val(),
                city       : $('#txtPaymentCity').val(),
                country    : $('#txtPaymentCountry').val(),
                email      : $('#txtPaymentEmail').val()
            };

            _.ajax.post('/handlers/payment/UpdateBilling', o).done(function(data) {
                if (data) {
                    that.startPayment(paymentID);
                } else {
                    _.showErrorMessage('Unable to continue', '.payment-js-error', false);
                    $('html, body').stop().animate({ 'scrollTop': 0 }, 400, 'swing');
                }
            }).fail(function(jqXHR, textStatus, errorThrown) {
                _.showErrorMessage(jqXHR.responseText || errorThrown, '.payment-js-error', false);
                $('html, body').stop().animate({ 'scrollTop': 0 }, 400, 'swing');
            });
        },

        btnCancelOnClick: function(paymentID, closeWindow) {
            this.removeBackOverlay();
            this.cancel(paymentID, closeWindow);
        },

        startPayment: function(paymentID) {
            this.redirect('Start', paymentID);
        },

        redirect: function(page, paymentID) {
            this.navigate(page, paymentID, window);
        },

        setPaymentComplete: function() {
            var context = getContext();
            context.mg.payment.paymentComplete = true;
        },

        showTerms: function(mode) {
            _.showTerms(mode)
        },

        createBackOverlay: function() {
            if ($('> #payment-overlay', 'body').length)
                return;

            $('body').append('<div class="payment-overlay" id="payment-overlay"></div>');

            var that     = this;
            var $overlay = $('> #payment-overlay', 'body');

            $overlay.on('click', function() {
                that.winRef && !that.winRef.closed && that.winRef.focus();
            });
        },

        removeBackOverlay: function() {
            var $overlay = $('> #payment-overlay', 'body');

            if (!$overlay.length)
                return;

            $overlay.remove();
        }
    };

    function monitor(callBackOnClose) {
        if (!payment.winRef)
            return;

        if (payment.winRef.closed) {
            payment.winRef = null;
            payment.removeBackOverlay();
            window.focus();
            callBackOnClose && callBackOnClose(payment.paymentComplete);
            return;
        }

        setTimeout(function() {
            monitor(callBackOnClose);
        }, 100);
    }

    function getContext() {
        return window.opener || window;
    }

    _.payment = payment;
})(jQuery, window);
